// extracted by mini-css-extract-plugin
module.exports = {"containerFullHeight":"Skeleton_containerFullHeight__TLOaK","containerItemsCenter":"Skeleton_containerItemsCenter__3DeTx"};